import {Film} from "@/modules/Rhizome/interfaces/film.interface";
import {Connection} from "@/modules/Rhizome/interfaces/connection.interface";

class DataSource {

  /**
   * Prepare data from server to rhizome films list.
   *
   * @param filmsResponse: Film.IFilmResponse[]
   */
  convertFilms(filmsResponse: Film.IFilmResponse[]): Film.IFilm[] {
    const filmsResult: Film.IFilm[] = filmsResponse.map((film: Film.IFilmResponse) => {
      let result: Film.IFilm = {
        id: Number(film.id),
        title: film.title,
        titleSort: film.title_sort_value,
        description: `${film.director}, ${film.year_display_value}`,
        imgPreview: film.image.thumbnail,
        imgLarge: film.image.large,
        year: Number(film.year),
        video_start: Number(film.video_start),
        loop_start: Number(film.loop_start),
        loop_end: Number(film.loop_end),
        year_display_value: Number(film.year_display_value),
      };
      if (!!film.video) result.video = film.video;
      if (film.related_films?.length) {
        result.connectionWith = film.related_films.map((connection: Connection.IConnectionResponse) => {
          let id = Number(connection.film_id);
          let weight = 0.5;
          switch (connection.line_width) {
            case Connection.IConnectionLineType.ONE:
              weight = 0.5;
              break;
            case Connection.IConnectionLineType.FEW:
              weight = 1;
              break;
            case Connection.IConnectionLineType.MORE:
              weight = 2;
              break;
            case Connection.IConnectionLineType.MANY:
              weight = 3;
              break;
          }
          return { id, weight };
        });
      }
      return result;
    });

    return filmsResult;
  }

  convertKeywords(serverKeywords: any): Film.IKeyword[] {
    const resultKeywords: Film.IKeyword[] = [];
    for (let key in serverKeywords) {
      resultKeywords.push({
        id: Number(serverKeywords[key].tid),
        value: serverKeywords[key].name,
      });
    }

    return resultKeywords;
  }
}

export const rhizomeDataSource = new DataSource();
